import type { ReactNode } from "react";
import { Link } from "react-router";
import { cx } from "./ui";

/** The sign-up / join attestation: an adult parent or guardian who agrees to the Terms and Privacy Policy. */
export function LegalCheckbox({ checked, onChange, children }: { checked: boolean; onChange: (v: boolean) => void; children?: ReactNode }) {
  return (
    <label className="flex cursor-pointer items-start gap-3 rounded-2xl bg-sunken/60 p-3 text-sm ring-1 ring-line/60">
      <input
        type="checkbox"
        required
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        className="mt-0.5 size-5 shrink-0 accent-[var(--color-brand)]"
      />
      <span>
        {children ?? "I'm 18 or older and the parent or legal guardian of the kids I'll add,"} and I agree to the{" "}
        <Link to="/terms" target="_blank" className="font-bold text-brand underline">
          Terms of Service
        </Link>{" "}
        and{" "}
        <Link to="/privacy" target="_blank" className="font-bold text-brand underline">
          Privacy Policy
        </Link>
        , including the Children's Privacy Notice.
      </span>
    </label>
  );
}

/** Footer links shown on public pages. */
export function LegalLinks({ className }: { className?: string }) {
  return (
    <p className={cx("text-center text-xs text-muted", className)}>
      <Link to="/privacy" className="font-semibold hover:text-ink">
        Privacy Policy
      </Link>
      <span aria-hidden> · </span>
      <Link to="/terms" className="font-semibold hover:text-ink">
        Terms of Service
      </Link>
    </p>
  );
}
